import { useState, useEffect, useCallback } from 'react';

export const useInfiniteScroll = (fetchFn, searchTerm = '', searchKeyType = '', checkDate = '', welfareFormFilter = '') => {
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);

    const loadMore = useCallback(async () => {
        if (loading || !hasMore) return;

        setLoading(true);
        try {
            const data = await fetchFn(page, searchTerm, searchKeyType, checkDate, welfareFormFilter);
            if (data.length < 20) {
                setHasMore(false);
            }
            setItems(prev => [...prev, ...data]);
            setPage(prev => prev + 1);
        } catch (error) {
            console.error("Error fetching data:", error);
            setHasMore(false);
        } finally {
            setLoading(false);
        }
    }, [fetchFn, page, searchTerm, searchKeyType, checkDate, welfareFormFilter, loading, hasMore]);

    useEffect(() => {
        setItems([]);
        setPage(1);
        setHasMore(true);
    }, [searchTerm, searchKeyType, checkDate, welfareFormFilter]);

    return { items, loadMore, loading, hasMore };
};



